// extracted by mini-css-extract-plugin
export default {"kontakt-page":"Index_kontakt-page__g7MVc","kontakt-page__contact-data":"Index_kontakt-page__contact-data__RtJ7b"};